import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=4e5d2367"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"
import style0 from "./Notice.vue?vue&type=style&index=0&id=4e5d2367&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports